import { Link, type LinkProps } from "react-router-dom";

import { useSelectedWorkspaceContext } from "common/context/SelectedWorkspaceContext";
import useWorkspaces from "common/datahooks/useWorkspaces";
import { getWhitelabelCustomization } from "common/helpers/utils";

// this link navigates relative to the selected workspaceId id
// i.e: 'home' becomes workspaces/:workspaceId/home

export default function RelativeLink({ to, ...rest }: LinkProps) {
  const { workspaces } = useWorkspaces();
  const { id: workspaceId } = useSelectedWorkspaceContext();

  const finalTo =
    getWhitelabelCustomization() && workspaces.length === 1
      ? `/${to}`
      : `/workspaces/${workspaceId}/${to}`;

  return <Link to={finalTo} {...rest} />;
}
